import React, { useState, useEffect } from 'react';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * SegmentControl Item Component
 * @param active {boolean} active segmentedControl item
 * @param children {ReactChild} React Child Element
 * @param onClick onClick Event
 * @param disabled {boolean} disable onClick on item
 * @param inverted {boolean} invert color of active item
 */
const SegmentControlItem = ({ active, onClick, disabled, className, children, }) => {
    const [activeItem, setActiveItem] = useState(active || false);
    const { styled } = useTrilogyContext();
    useEffect(() => {
        setActiveItem(active || false);
    }, [active]);
    return (React.createElement("button", { disabled: disabled, className: hashClass(styled, clsx('segmented-control-item', className, { 'is-active': activeItem })), onClick: (e) => {
            const target = e.target;
            setActiveItem(active || false);
            target.active = active;
            if (onClick) {
                onClick(e);
            }
        } }, children));
};
export default SegmentControlItem;
//# sourceMappingURL=SegmentControlItem.js.map